if (!customElements.get('zone-finder-display')) {
  customElements.define(
    'zone-finder-display',
    class ZoneFinderDisplay extends HTMLElement {
      // Use the same storage key as other zone components
      static STORAGE_KEY = 'zone-finder-data';

      constructor() {
        super();
        
        // Store reference to DOM elements
        this.zoneHeading = this.querySelector('.zone-finder-display__zone');
        //this.cityElement = this.querySelector('.zone-finder-display__city');
        this.zipElement = this.querySelector('.zone-finder-display__zip');
        this.buttonElement = this.querySelector('.zone-finder-display__button');
        this.buttonLabel = this.querySelector('.zone-finder-display__label');
        this.shopButton = this.querySelector('.zone-finder-display__shop-button');
        
        // Store unsubscribe function
        this.unsubscribeZoneUpdate = null;
        
        // Bind event handlers
        this.handleZoneUpdate = this.handleZoneUpdate.bind(this);
        this.handleShopButtonClick = this.handleShopButtonClick.bind(this);

      }

      connectedCallback() {
        // Subscribe to zone update events
        this.unsubscribeZoneUpdate = subscribe(PUB_SUB_EVENTS.zoneUpdate, this.handleZoneUpdate);
        
        // Set up shop button click handler if it exists
        if (this.shopButton) {
          this.shopButton.addEventListener('click', this.handleShopButtonClick);
        }
        
        // Load stored data and update display
        this.loadStoredZoneData();
      }

      disconnectedCallback() {
        // Clean up subscription
        if (this.unsubscribeZoneUpdate) {
          this.unsubscribeZoneUpdate();
          this.unsubscribeZoneUpdate = null;
        }

        // Clean up shop button event listener
        if (this.shopButton) {
          this.shopButton.removeEventListener('click', this.handleShopButtonClick);
        }
      }

      handleZoneUpdate(eventData) {
        // Update display with new zone data from the event
        if (eventData && eventData.zipCode && eventData.zoneData && eventData.zoneData.success) {
          this.updateZoneDisplay(eventData.zipCode, eventData.zoneData);
        }else{
          this.zoneHeading.classList.remove('loading-shimmer');
        }
      }

      updateZoneDisplay(zipCode, zoneData) {
        const { zone, city, collectionURL } = zoneData;
        
        // Update zone
        if (this.zoneHeading) {
          this.zoneHeading.textContent = ': ' + zone;
          this.zoneHeading.classList.remove('loading-shimmer');
        }
        
        // Update city
        // if (this.cityElement) {
        //   this.cityElement.textContent = city;
        //   this.cityElement.classList.remove('loading-shimmer');
        // }
        
        // Update zip  
        // if (this.zipElement) {
        //   this.zipElement.textContent = zipCode;
        //   this.zipElement.classList.remove('loading-shimmer');
        // }
        
        // Update button text and state
        // if (this.buttonLabel) {
        //   this.buttonLabel.textContent = 'Change Zone';
        // }
        if (this.buttonElement) {
          this.buttonElement.style.display = 'none'; 
        }

        // Update shop button href and show it
        if (this.shopButton) {
          this.shopButton.href = collectionURL;
          this.shopButton.style.display = 'inline-flex';
          this.shopButton.classList.remove('loading-shimmer');
        }
      }

      loadStoredZoneData() {
        try {
          const storedData = localStorage.getItem(ZoneFinderDisplay.STORAGE_KEY);
          
          if (storedData) {
            const parsedData = JSON.parse(storedData);
            
            // Validate the stored data structure
            if (parsedData.zipCode && parsedData.zoneData && parsedData.zoneData.success) {
              this.updateZoneDisplay(parsedData.zipCode, parsedData.zoneData);
              return true; // Data was loaded successfully
            }
          }
        } catch (error) {
          console.warn('Unable to load stored zone data for display:', error);
        }
        
        // Always remove loading shimmer classes, regardless of outcome
        this.removeLoadingState();
        return false; // No data was loaded
      }

      removeLoadingState() {
        // Remove loading shimmer from all elements
        [this.zoneHeading, this.cityElement, this.zipElement, this.buttonElement, this.shopButton]
          .filter(Boolean)
          .forEach(el => el.classList.remove('loading-shimmer'));
      }

      handleShopButtonClick(event) {
        // Optional: Add analytics tracking or other logic here
        // The href will handle the navigation
      }

      clearStoredZoneData() {
        try {
          localStorage.removeItem(ZoneFinderDisplay.STORAGE_KEY);
          // Reset the display to initial state
          if (this.zoneHeading) this.zoneHeading.textContent = '';
          if (this.cityElement) this.cityElement.textContent = '';
          if (this.zipElement) this.zipElement.textContent = '';
          if (this.buttonLabel) this.buttonLabel.textContent = 'Find My Zone';
          if (this.buttonElement) this.buttonElement.classList.remove('active');
          if (this.shopButton) this.shopButton.style.display = 'none';
          
          // Add loading shimmer back
          [this.zoneHeading, this.cityElement, this.zipElement, this.buttonElement, this.shopButton]
            .filter(Boolean)
            .forEach(el => el.classList.add('loading-shimmer'));
        } catch (error) {
          console.warn('Unable to clear stored zone data:', error);
        }
      }
    }
  );
}